var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "flex flex_gap_10" },
    [
      _c(
        "v-popover",
        {
          staticClass: "d-inline",
          attrs: { placement: "bottom", "auto-hide": true },
        },
        [
          _c("i", {
            staticClass: "icon-fa icon-fa-photo pointer",
            on: { click: _vm.uploadImage },
          }),
          _vm._v(" "),
          _c(
            "template",
            { slot: "popover" },
            [
              !_vm.drugsImage
                ? [_vm._v("\n          Loading...\n        ")]
                : [_c("img", { attrs: { src: _vm.drugsImage, alt: "" } })],
            ],
            2
          ),
        ],
        2
      ),
      _vm._v(" "),
      _c("div", [
        _c("p", [_vm._v(_vm._s(_vm.drug.title))]),
        _vm._v(" "),
        _c("p", [_vm._v(_vm._s(_vm.drug.en_title))]),
        _vm._v(" "),
        _vm.drug.pack_box_comment
          ? _c("p", { staticClass: "text-muted" }, [
              _vm._v(_vm._s(_vm.drug.pack_box_comment)),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.drug.cool
          ? _c("p", [
              _c("i", { staticClass: "icon icon-snowflake pull-left mr-2" }),
              _vm._v(" Требуется хладоген"),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.drug.pack_set != 1
          ? _c("p", [
              _c("span", { staticClass: "badge badge-info" }, [
                _vm._v(
                  "1 комплект (" + _vm._s(+_vm.drug.pack_set) + " зав.уп.)"
                ),
              ]),
            ])
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }